import { createContext } from "react";

import { NotificationsContextState } from "./types";

const NotificationsContext = createContext({} as NotificationsContextState);

export default NotificationsContext;
